import {
  SearchParams
} from '../const';

/**
 * Создаёт url из формы фильтра и важных параметров
 * @param {array} saveParams - параметры, которые необходимо сохранить
 * @return {Object} Объект url
 */
export function setSearchParams(saveParams) {

  const filters = document.querySelector('.filters');
  const formData = new FormData(filters);

  const url = new URL(window.location.href);

  const formDataWithResolveParam = saveGoodParams(url, formData, saveParams);
  const clearUrl = removeParams(url);
  const urlWithChar = addСharParams(clearUrl, formDataWithResolveParam);
  pushHistoryState(urlWithChar);
  return urlWithChar;
}

export function setStartParam(url) {
  const loadmoreUrl = new URL(url);
  const startPage = loadmoreUrl.searchParams.get('start');
  if (startPage) {
    let currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('start', startPage);
    pushHistoryState(currentUrl);
  }
}

/**
 * Добавление в формдату важных параметров из ссылки
 * @param {Object} url - объект url из действующей ссылки на страницу
 * @param {Object} formData - объект формы фильтра
 * @param {array} saveParams - массив ключей, которые необходимо сохранить
 * @return {Object} Объект формы с допключами
 */
function saveGoodParams(url, formData, saveParams) {
  if (saveParams.length > 0) {
    saveParams.forEach(value => {
      const key = url.searchParams.get(value);
      if (key) {
        formData.append(value, key);
      }
    });
  }
  return formData;
}

/**
 * Создаёт url из FormData, добавляя параметры search
 * @param {Object} url
 * @param {Object} formData
 * @return {Object} Новый url
 */
function addСharParams(url, formData) {
  for (const iterator of formData.entries()) {
    if (isNotBadParam(iterator) && isNotBusyParam(url, iterator)) {
      url.searchParams.append(iterator[0], iterator[1]);
    }
  }
  return url;
}

function pushHistoryState(url) {
  const state = {
    title: document.title,
    url: url.href
  };

  history.pushState(state, state.title, state.url);
}

function isNotBadParam(iterator) {
  return (iterator[1] !== '') && !SearchParams.BAD.some(it => it === iterator[0]);
}

function isNotBusyParam(url, iterator) {
  if (isHaveBrand(url) && iterator[0] === 'manufacturers[]') {
    return false;
  }
  if (isHaveModel(url) && iterator[0] === 'characteristics[16][]') {
    return false;
  }
  return true;
}

function isHaveBrand(url) {
  return url.pathname.indexOf('/mf-') !== -1;
}

function isHaveModel(url) {
  return url.pathname.indexOf('/model-') !== -1;
}

function removeParams(url) {
  url.search = '';
  return url;
}
